import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LayerInfo } from '@root/search/models/map.models';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { ToggleBoundary } from '@store/search-board/search-board.actions';
import { selectBoundaries, selectLayersLimitReached, selectSelectedBoundaries } from '@store/map-layers.selector';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SearchMixpanelUtil } from '@root/search/search-mixpanel-util';
import { SidePanelTab, SidePanelView } from '@store/search-board/search-board.model';
import { MixpanelService } from '@shared/services/mixpanel.service';
import { Observable } from 'rxjs';
import { selectSidePanelState } from '@store/search-board/search-board.selector';

@UntilDestroy()
@Component({
  selector: 'rlst-map-boundaries',
  templateUrl: './map-boundaries.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})

export class MapBoundariesComponent implements OnInit {
  public boundaryLayers$: Observable<Array<LayerInfo>>;
  public selectedBoundaries$: Observable<Array<LayerInfo>>;
  public layersLimitReached: boolean = false;

  private sidePanelTabOpened: SidePanelTab;
  private readonly searchMixpanelUtil: SearchMixpanelUtil = new SearchMixpanelUtil(this.store$);

  constructor(
    private readonly store$: Store<AppState>,
    private readonly mixpanelService: MixpanelService) {
  }

  ngOnInit() {
    this.boundaryLayers$ = this.store$.pipe(select(selectBoundaries));
    this.selectedBoundaries$ = this.store$.pipe(select(selectSelectedBoundaries));

    this.store$.pipe(
      select(selectLayersLimitReached),
      untilDestroyed(this)
    )
      .subscribe((limitReached: boolean) => this.layersLimitReached = limitReached);

    this.store$
      .pipe(
        select(selectSidePanelState),
        untilDestroyed(this)
      )
      .subscribe((sidePanelView: SidePanelView) => {
        this.sidePanelTabOpened = sidePanelView.sidePanelTabOpened;
      });
  }

  trackByFn(_: any, item: LayerInfo) {
    return item.layerId;
  }

  public toggleBoundary(boundary: LayerInfo): void {
    if (!boundary.isSelected) {
      this.logMapBoundariesMixPanel('Search - Boundary Added', boundary.label);
    } else {
      this.logMapBoundariesMixPanel('Search - Boundary Removed', boundary.label);
    }
    this.store$.dispatch(new ToggleBoundary(boundary));
  }

  private logMapBoundariesMixPanel(eventId: string, boundaryType: string) {
    this.searchMixpanelUtil.setupMixPanelItems(this.sidePanelTabOpened);

    this.mixpanelService.track(eventId, {
      countyList: this.searchMixpanelUtil.countyList,
      searchType: this.sidePanelTabOpened,
      isSavedSearch: (this.sidePanelTabOpened === 'quickSearch') ? false :
        this.searchMixpanelUtil.selectedSearch !== 'My Search Default',
      searchParameters: this.searchMixpanelUtil.searchFieldNames.join('; '),
      boundaryType: boundaryType
    });
  }
}
